import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { Subsection } from 'src/app/models/subsection';

export const setSelectedSubsection = createAction(
  '[Subsection] Set Selected Subsection',
  props<{ selectedSubsection: Subsection }>()
);

export const getSubsections = createAction('[Subsection] Get Subsections', props<{ subsections: Subsection[] }>());

export const createSubsection = createAction('[Subsection] Create Subsection', props<{ subsection: Subsection }>());

export const createSubsectionSuccess = createAction(
  '[Subsection] Create Subsection Success',
  props<{ createdSubsection: Subsection }>()
);

export const createSubsectionError = createAction(
  '[Subsection] Create Subsection Error',
  props<{ err: HttpErrorResponse }>()
);

export const updateSubsection = createAction('[Subsection] Update Subsection', props<{ subsection: Subsection }>());

export const updateSubsectionSuccess = createAction(
  '[Subsection] Update Subsection Success',
  props<{ updatedSubsection: Subsection }>()
);

export const updateSubsectionError = createAction(
  '[Subsection] Update Subsection Error',
  props<{ err: HttpErrorResponse }>()
);

export const deleteSubsection = createAction('[Subsection] Delete Subsection', props<{ subsection: Subsection }>());

export const deleteSubsectionSuccess = createAction(
  '[Subsection] Delete Subsection Success',
  props<{ deletedSubsection: Subsection }>()
);

export const deleteSubsectionError = createAction(
  '[Subsection] Delete Subsection Error',
  props<{ err: HttpErrorResponse }>()
);

export const noopAction = createAction('[Section] No Operations Action');
